import React, { useContext, useState } from 'react'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { DataContext } from '../../../js/App'

import './RadioSelect.scss'
import { PROVIDER_ID } from '../../../config';

const RadioSelect = ({name, type, fieldLabel, options}) => {
    const context = useContext(DataContext);
    const {handleChange, howdenNumbers, dataReady} = context;
    const [modalMessage, setModalMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const howdenOnChange = (e, value) => {
        handleChange(e, value);
        const messages = options.AlertMessage[0];
        if(options.nextStepOn == value){
            if(howdenNumbers !== null && howdenNumbers.windscreenNumber !== '' && messages.Message.includes('#phoneNumberWindscreen')){
                const realMessage = messages.Message.replace(
                    new RegExp('#phoneNumberWindscreen', 'g'),
                    howdenNumbers.windscreenNumber
                );
                setModalMessage(realMessage);
            } else if(howdenNumbers !== null && howdenNumbers.roadsideNumber !== '' && messages.Message.includes('#phoneNumberRoadside')){
                const realMessage = messages.Message.replace(
                    new RegExp('#phoneNumberRoadside', 'g'),
                    howdenNumbers.roadsideNumber
                );
                setModalMessage(realMessage);
            } else {
                setModalMessage(messages.AltMessage);
            }
            handleShow();
        } else if(showModal === true) {
            handleClose();
        }
    }

    if(PROVIDER_ID == 84 && !dataReady && typeof options.AlertMessage !== 'undefined'){
        return(<Spinner animation="border" variant="primary" />)
    }
            
    
    return (        
        <Form.Group as={Row} className="mb-3" controlId="radioSelect">
            <Form.Label column sm="5">
                {fieldLabel}
            </Form.Label>
            <Col sm="7" className="inlineOptions">
                {options.options.map((option, index) => (
                    <Form.Check
                    inline
                    onChange={e => PROVIDER_ID !== 84 ? handleChange(e, option.value) : howdenOnChange(e, option.value)}
                    key={index}
                    label={option.value}
                    name={name}
                    type={type}
                    id={`inline-${type}-${index}`}
                    />
                ))}
             </Col>
             {PROVIDER_ID === 84 && (
                <Modal show={showModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Please Read It!</Modal.Title>
                    </Modal.Header>
                    <Modal.Body dangerouslySetInnerHTML={{__html: modalMessage}}></Modal.Body>
                </Modal>
             )}
        </Form.Group>     
    )
}

export default RadioSelect;
